import { PaginaCrud } from '../components/PaginaCrud'
import type { Empresa } from '../types'

export default function Empresas() {
  return (
    <PaginaCrud<Empresa>
      titulo="Empresas"
      recurso="empresas"
      llave="id"
      columnas={[
        { campo: 'nombre', titulo: 'Nombre' },
        { campo: 'subdominio', titulo: 'Subdominio' },
        { campo: 'correo', titulo: 'Correo', render: (e) => e.correo || '-' },
        { campo: 'telefono', titulo: 'Telefono', render: (e) => e.telefono || '-' },
        { campo: 'fechaRegistro', titulo: 'Registro', render: (e) => (e.fechaRegistro ? e.fechaRegistro.slice(0, 10) : '-') },
        { campo: 'activo', titulo: 'Activo', render: (e) => (e.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'nombre', etiqueta: 'Nombre', tipo: 'texto', requerido: true },
        { nombre: 'subdominio', etiqueta: 'Subdominio', tipo: 'texto', requerido: true },
        { nombre: 'correo', etiqueta: 'Correo', tipo: 'texto' },
        { nombre: 'telefono', etiqueta: 'Telefono', tipo: 'texto' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ activo: true }}
    />
  )
}
